import classNames from 'classnames';
import React from 'react';
import styles from './vote-arrow.module.scss';
const VoteArrow = ({ ariaLabel, disabled, active, flip = false, onClick, component, dataHook, className }) => {
    const [isAnimated, setIsAnimated] = React.useState(false);
    return (React.createElement("button", { "data-hook": dataHook, "aria-label": ariaLabel, "aria-pressed": active ? 'true' : 'false', className: classNames(styles.container, {
            [styles.active]: active,
            [styles.disabled]: disabled,
            [styles.isAnimated]: isAnimated,
        }, className), onClick: () => {
            !isAnimated && setIsAnimated(true);
            onClick?.();
        } }, React.cloneElement(component, { style: { transform: flip ? 'scaleY(-1)' : '' } })));
};
export default VoteArrow;
//# sourceMappingURL=vote-arrow.js.map